import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export function getUnpauseSubscriptionSuccessStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.UnpauseSubscriptionSuccess,
    type: 'custom',
    allowNext: true,
    wordings: {
      title: t(`${ManageSubscriptionStepId.UnpauseSubscriptionSuccess}.${title}`)
    }
  }
}
